
import { Component, Vue, Ref } from "vue-property-decorator";
import AppCard from "@/modules/shared/components/AppCard.vue";
import AppButton from "@/modules/shared/components/AppButton.vue";
import { EntityListProvider } from "@/modules/shared/classes/entity-list.provider";
import { IdentityProvidersDirector } from "@/modules/identity-providers/identity-providers.director";

const IdentityProvidersList = IdentityProvidersDirector.createIndexList();

@Component({
  components: {
    AppCard,
    AppButton,
    IdentityProvidersList,
  },
})
export default class IdentityProvidersIndex extends Vue {
  @Ref()
  private readonly entityProvider!: EntityListProvider;
}
